export default __webpack_public_path__ + "static/media/Niger.7dda36b0.png";